// import React, { useEffect, useState } from "react";
// import { useDispatch, useSelector } from "react-redux";
// import { updateCoordinate } from "../../../../../store/PdfEditor/pdfCoordinatesSlice";
// import styled from "styled-components";

// function RotateShape() {
//   let [localRotation, setLocalRotation] = useState(0);
//   const { currVariable } = useSelector((state) => state.toolsModification);
//   console.log("currVariable in RotateShape", currVariable);
//   const dispatch = useDispatch();
//   // useEffect(() => {
//   //     dispatch(currentBoxSize(boxSize));
//   //   }, [boxSize]);
//   const handleChange = (e) => {
//     if(e.target.value<0) return
//     let name = e.target.name;
//     let value = Number(e.target.value);
//     let data = { [name]: `${value}` };
//     console.log("data for rotation", data)
//     dispatch(updateCoordinate({ id: currVariable?.variable, newValue: data }));
//     setLocalRotation(value)
//   };

//   useEffect(()=>{
//     setLocalRotation(currVariable?.rotation)
//   },[currVariable])

//   return (
//     <Wrapper style={{ position: "relative", left: "80px", width: "40px" }}>
//       {/* <Wrapper style={{position:'relative', left:'98px',top:'8px',width:'40px'}} > */}
//       <input
//         type="number"
//           value={ localRotation || currVariable?.rotation}
//         onChange={handleChange}
//         name="rotation"
//         autoFocus
//         style={inputStyle}
//         min={0}
//         step={1}
//         max={360}
//       />
//     </Wrapper>
//   );
// }

// export default RotateShape;
// const inputStyle = {
//   width: "100%",
//   height: "33px",
//   borderRadius: "5px",
//   // border:'2px solid black'
// };
// const Wrapper = styled.div`
//   input::-webkit-outer-spin-button,
//   input::-webkit-inner-spin-button {
//     -webkit-appearance: none;
//     margin: 0;
//   }
//   .size-display {
//     display: flex;
//     align-items: center;
//     width: auto;
//   }
//   p {
//     font-size: 12px;
//   }
// `;


import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { updateCoordinate } from "../../../../../store/reducers/pdfeditor/pdfCoordinatesSlice";
import styled from "styled-components";

function RotateShape() {
  let [localRotation, setLocalRotation] = useState(0);
  const { currVariable } = useSelector((state) => state.toolsModification);
  const dispatch = useDispatch();

  const handleChange = (e) => {
    let value = Number(e.target.value);

    // Prevent value from going below 0 and above 360
    if (value < 0 || value > 360) return;

    let name = e.target.name;
    let data = { [name]: `${value}` };

    // Update Redux store with the new value
    dispatch(updateCoordinate({ id: currVariable?.variable, newValue: data }));

    // Update local state
    setLocalRotation(value);
  };

  useEffect(() => {
    // Initialize localRotation when currVariable changes
    setLocalRotation(currVariable?.rotation || 0); // Default to 0 if no value
  }, [currVariable]);

  return (
    <Wrapper style={{ position: "relative", left: "80px", width: "40px" }}>
      <input
        type="number"
        value={localRotation} // Controlled by local state
        onKeyDown={(e) => {
          if (["e", "E", "+", "-", "."].includes(e.key)) {
            e.preventDefault();
          }
        }}
        onPaste={(e) => {
            const paste = e.clipboardData.getData('text');
            if (!/^\d+$/.test(paste)) {
              e.preventDefault();
            }
        }}
        onChange={handleChange}
        name="rotation"
        style={inputStyle}
        min={0}
        max={360}
        step={1}
        autoFocus
      />
    </Wrapper>
  );
}

export default RotateShape;

const inputStyle = {
  width: "100%",
  height: "33px",
  borderRadius: "5px",
};

const Wrapper = styled.div`
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }
  .size-display {
    display: flex;
    align-items: center;
    width: auto;
  }
  p {
    font-size: 12px;
  }
`;
